import { render } from "./InstanceTab.vue?vue&type=template&id=df7a42ee&scoped=true"
import script from "./InstanceTab.vue?vue&type=script&lang=js"
export * from "./InstanceTab.vue?vue&type=script&lang=js"

import "./InstanceTab.vue?vue&type=style&index=0&id=df7a42ee&lang=scss&scoped=true"
import "./InstanceTab.vue?vue&type=style&index=1&id=df7a42ee&scoped=true&lang=css"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df7a42ee"]])

export default __exports__